<template>
  <b-container>
    <div class=" user-listing-container">
      <div>
        <h2>Users</h2>
      </div>
      <div class=" user-listing-container">
        <div>
          <input class="search-bar-ul" v-model="search" placeholder="search" />
        </div>
        <b-button variant="primary" @click="openAddAgentModal">
          Add New User
        </b-button>
      </div>
    </div>

    <AddAgentFormModal
      class="add_agent_btn"
      :createDialog="showAddAgentForm"
      @eCloseCreateAddAgentFormModal="closeCreateAddAgentFormModal"
    />

    <b-row>
      <b-col cols="10" class="user-table">
        <UserListingTable
          :search="search"
          @view="this.viewActivityLog"
          v-model="selected"
          @deleted="this.confirmDelete"
          v-if="showList"
          @editPermissions="this.editPermissions"
        />
        <AgentPermissions :agent="agent" @back="this.exitPermissions" v-else />
      </b-col>
    </b-row>

    <LoadingModal v-bind="loadingModal" />
    <AlertModal
      v-bind="alertModal"
      v-model="alertModal.show"
      @dismiss="resetAlert"
    />
    <ConfirmationModal
      v-bind="confirmationModal"
      v-model="confirmationModal.show"
      @dismiss="resetConfirmation"
    />
  </b-container>
</template>

<style scoped>
.user-listing-container {
  display: flex;
  justify-content: space-between;
  align-item: center;
}
.search-bar-ul {
  height: 100%;
  width: 300px;
  font-size: 1.3rem;
  padding: 0 1rem;
  border-radius: 8px;
  border: thin solid grey;
  outline: none;
  margin-right: 1rem;
}
.search-bar-u::placeholder {
  color: grey;
}
.search-bar-u:focus {
  outline: none !important;
  border: none;
}
</style>
<script>
import UserListingTable from "@/components/tables/UserListingTable.vue";
import UserListingPermissionsMixin from "@/components/userlisting/UserListingPermissionsMixin.js";
import AlertModalMixin from "@/components/widgets/AlertModalMixin.js";
import AddAgentFormModal from "@/components/widgets/AddAgentFormModal.vue";
import AgentPermissions from "@/components/forms/AgentPermissions.vue";
import { API, Auth } from "aws-amplify";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";

const AlertModal = AlertModalMixin.AlertModal;
const LoadingModal = AlertModalMixin.LoadingModal;
const ConfirmationModal = AlertModalMixin.ConfirmationModal;

export default {
  mixins: [UserListingPermissionsMixin, AlertModalMixin],
  components: {
    UserListingTable,
    AddAgentFormModal,
    AgentPermissions
  },
  props: {
    createDialog: Boolean
  },
  data() {
    return {
      showList: true,
      showAddAgentForm: false,
      search: "",
      selected: [],
      agent: {}
    };
  },
  computed: {
    activityLogPage() {
      return this.isAdmin ? "admin-activity-log" : "activity-log";
    },
    deleteUserEndpoint() {
      if (this.isMerchantAdmin || this.hasDeleteUserPermissions)
        return "/merchantDeleteUser";
      return "";
    },
    disableSingleItemOperations() {
      return !!this.selected && this.selected.length != 1;
    },
    currentUsername() {
      return this.$store.getters.currentUser.username;
    }
  },
  methods: {
    openAddAgentModal() {
      this.showAddAgentForm = true;
    },
    editPermissions(agentItem) {
      this.agent = agentItem;
      this.showList = false;
    },
    exitPermissions() {
      this.agent = null;
      this.showList = true;
    },

    closeCreateAddAgentFormModal() {
      this.showAddAgentForm = false;
    },
    viewActivityLog(item) {
      if (!this.hasViewActivityLogPermission) return;
      if (!item) return;
      const email = item.email;
      this.$router.push({ name: this.activityLogPage, params: { email } });
    },
    async confirmDelete(items) {
      //if (this.disableSingleItemOperations) return;
      if (!this.hasDeleteUserPermissions) {
        this.alert(
          "You do not have the required permissions to delete a user.",
          AlertModal.WARNING
        );
        return;
      }
      const item = items;
      if (item.role != "User") {
        this.alert("Merchant Admins cannot be deleted.", AlertModal.WARNING);
        return;
      }

      if (item.username === this.currentUsername) {
        this.alert("You cannot delete your own account.", AlertModal.WARNING);
        return;
      }
      const name = !!item.name ? item.name : item.email;

      const confirm = await this.confirm(
        `Delete User?`,
        `Are you sure you want to delete user ${name}?`,
        ConfirmationModal.WARNING
      );
      if (!confirm) return;
      let requestMessage = `Successfully deleted ${name}`;
      let alertType = AlertModal.SUCCESS;
      this.startLoadingDialog(`Deleting ${name}`);
      try {
        await this.deleteUser(item.username);
      } catch (err) {
        this.$logger.error(err);
        requestMessage = `There was an error deleting ${name}. (error code: 02)`;
        alertType = AlertModal.ERROR;
      }
      this.stopLoadingDialog(requestMessage, alertType);
    },
    async deleteUser(username) {
      if (!this.hasDeleteUserPermissions) return;

      try {
        let payload = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`
          },
          body: {
            username
          }
        };

        const result = await API.del(
          "AdminQueries",
          this.deleteUserEndpoint,
          payload
        );
        return result;
      } catch (err) {
        throw err;
      }
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Users" }]);
  }
};
</script>

<style lang="scss" scoped>
.user-table {
  min-width: 100%;
}
.above_table {
  padding-right: 20px;
}

.search_bar {
  min-width: 343px;
}
</style>
